import { useLocation, useHistory } from "react-router-dom";

export function useQueryParams() {
  const { search, pathname } = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(search);

  const setAllQuery = (updates: Record<string, string | null>) => {
    const newParams = new URLSearchParams(search);

    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in updates) {
      const value = updates[key];
      if (value === null) {
        newParams.delete(key);
      } else {
        newParams.set(key, value);
      }
    }

    history.push({ pathname, search: newParams.toString() });
  };

  return {
    search,
    getQuery: (key: string) => params.get(key),
    setAllQuery
  };
}

export default useQueryParams;
